import React from 'react';

const DevPage = () => {
  return <div>DevPage</div>;
};

export default DevPage;
